import React, { useCallback } from "react"
import { Button, Col, Form, Menu, Row, Spin } from "antd"
import TableActionsDropdown from "components-old/common/TableActionsDropdown"
import { Link, RouteComponentProps, useHistory } from "react-router-dom"
import { capitalizeWords, verifyPermission } from "lib/helper"
import Truncate from "components-old/common/Truncate"
import { useGenericStore, useStore, useStoreActions, useStoreState } from "hooks"
import MenuLink from "components-old/menu/MenuLink"
import SearchInput from "components-old/common/SettingsPage/SearchInput"
import { IChannel, IChannelStatus } from "models/channels"
import EditChannel from "./EditChannel"
import { channelsTypes, CHANNEL_TYPES, WhatsappVersion } from "lib/constants"
import masks from "lib/masks"
import Avatar from "components-old/ui/Avatar"
import wppImg from "assets/images/channels/whatsapp.svg"
import instagramImg from "assets/images/channels/instagram.svg"
import mlImg from "assets/images/channels/mercado-livre.png"
import telegramImg from "assets/images/channels/telegram.svg"
import facebookRoundImg from "assets/images/channels/facebook-round.svg"
import emailImg from "assets/images/channels/email.svg"
import smsImg from "assets/images/channels/sms.png"
import widgetImg from "assets/images/channels/widget.svg"
import customImg from "assets/images/channels/custom.svg"
import toast from "lib/toast"
import { useAtom, useSetAtom } from "jotai"
import { isMobileAtom, modalState } from "atoms/app.atom"
import _ from "lodash"
import request from "lib/request"
import { endpoints } from "config/endpoints.config"
import { IChannelWhatsApp } from "models/channelsWhatsapp"
import SyncZapHistoryModal from "./whatsapp/SyncZapHistoryModal"
import { general, session } from "store"
import ForwardZapModal from "./whatsapp/ForwardZapModal"
import { IWorkspace } from "models/workspaces"
import { formatCustomInputValue } from "lib/formatInputValue"
import TablePageRouter from "components-old/shared/table/TablePageRouter"
import { ColumnDef } from "@tanstack/react-table"
import { isAldeia } from "hooks/useAldeia"
import { channelsDef } from "./channels.def"
import { ChannelIcon } from "./ChannelIcon"
import { cn, showDeleteModalConfirm, showInfoModalConfirm } from "lib/utils"
import { DefaultTableSegment } from "components-old/shared/table/table.helper"
import copy from "copy-to-clipboard"
import { Copy01Icon } from "components-old/icons"
import Separator from "components/navigation/Separator"
import { channelIsInUserGroups } from "components-old/ui/ChannelsSelect"
import Tooltip from "components-old/Tooltip"

export const ChannelStatus = (props: { status?: IChannelStatus; truncateMobile?: boolean; channel?: IChannel }) => {
  // const [isMobile, setIsMobile] = useAtom(isMobileAtom)
  if (!props.status) {
    return <span />
  }
  let status2
  try {
    const isNotUpdated =
      !props.channel?.lastCreatedAt || new Date(props.channel?.lastCreatedAt!) < new Date("2023-01-09 00:00:00.740 -0300")
    if (props.channel?.channelId == CHANNEL_TYPES.WHATSAPP && props.channel?.version == WhatsappVersion.BAILEYS && isNotUpdated) {
      status2 = (
        <Tooltip
          title={`Canal desatualizado. Recomendado recriar. Vá no seu canal, clique em "ações" e em Recriar canal. Será necessário ler o QRCode novamente.`}
        >
          <span className="contract-status channels-status" style={{ backgroundColor: "rgb(255, 234, 167)", color: "#000" }}>
            {props.truncateMobile ? _.truncate("Recomendado recriar canal", { length: 10 }) : "Recomendado recriar canal"}
          </span>
          {/* {props.status == "qr_code" && !isMobile && (
                    <i className="fal fa-qrcode" style={{ fontSize: 18, marginLeft: 20 }} />
                )} */}
        </Tooltip>
      )
    }
  } catch (e) {
    console.log(e)
  }

  const statusProps = getStatus(props.status)

  if (props.status == "connected") {
    return (
      <>
        <Tooltip title={statusProps.description}>
          <i className="fas fa-badge-check" style={{ color: "#4dad55", fontSize: 20 }} />
        </Tooltip>
        {status2}
      </>
    )
  }

  return (
    <>
      <Tooltip title={statusProps.description}>
        <span
          className={cn(
            "contract-status channels-status ",
            isAldeia && statusProps.className,
            isAldeia && "flex items-center gap-2 capitalize font-semibold pl-1.5",
          )}
          style={{ backgroundColor: statusProps.bg, color: statusProps.color || "white" }}
        >
          {isAldeia && statusProps.icon}
          {props.truncateMobile ? _.truncate(statusProps.title, { length: 10 }) : statusProps.title}
        </span>
        {/* {props.status == "qr_code" && !isMobile && (
                <i className="fal fa-qrcode" style={{ fontSize: 18, marginLeft: 20 }} />
            )} */}
      </Tooltip>
      {status2}
    </>
  )
}

export function getProps(item?: Partial<IChannel>, workspace?: IWorkspace) {
  // console.log("workspace", workspace?.sms_credits)

  if (isAldeia) {
    try {
      return channelsDef.recordByCode[item?.channelId!]?.getProps(item as any, workspace as any)
    } catch (e) {
      console.log(e)
    }
  }

  if (item?.channelId == CHANNEL_TYPES.SMS) {
    return {
      name: "SMS",
      description: (workspace?.sms_credits || 0) + " créditos",
      img: smsImg,
      to: "/settings/channels/sms/" + item?.id,
    }
  }
  if (item?.channelId == CHANNEL_TYPES.WIDGET) {
    return {
      name: "Widget",
      description: "",
      img: widgetImg, //"https://cdn-icons-png.flaticon.com/512/736/736114.png",
      to: "/settings/channels/widget/" + item?.id,
    }
  }
  if (item?.channelId == CHANNEL_TYPES.FACEBOOK) {
    return {
      name: item?.description,
      description: "Página do Facebook",
      img: facebookRoundImg,
      to: "/settings/channels/facebook/" + item?.id,
    }
  }
  if (item?.channelId == CHANNEL_TYPES.WHATSAPP) {
    return {
      name: item?.description,
      description: `${masks.cell(item?.phone)}`,
      icon: (
        <i
          className="fab fa-whatsapp"
          style={{
            fontSize: 18,
            width: 30,
            height: 30,
            backgroundColor: "#3d9c4c",
            color: "#fff",
            borderRadius: "50%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        />
      ),
      img: wppImg,
      iconStyle: {
        backgroundColor: "#f1fbf6",
      },
      to:
        item?.version == WhatsappVersion.BAILEYS
          ? "/settings/channels/whatsapp/" + item?.id
          : "/settings/channels/whatsapp-cloud-api/" + item?.id,
    }
  }
  if (item?.channelId == CHANNEL_TYPES.INSTAGRAM) {
    return {
      name: item?.description,
      description: "Instagram Direct",
      img: instagramImg,
      iconStyle: {
        backgroundColor: "#f1fbf6",
      },
      to: "/settings/channels/instagram/" + item?.id,
    }
  }
  if (item?.channelId == CHANNEL_TYPES.MERCADO_LIVRE) {
    return {
      name: item?.description,
      description: "Mercado Livre",
      img: mlImg,
      iconStyle: {
        backgroundColor: "#f1fbf6",
      },
      to: "/settings/channels/mercado-livre/" + item?.id,
      rounded: true,
    }
  }
  if (item?.channelId == CHANNEL_TYPES.TELEGRAM) {
    return {
      name: item?.description,
      description: "Bot do telegram",
      img: telegramImg,
      to: "/settings/channels/telegram/" + item?.id,
    }
  }
  if (item?.channelId == CHANNEL_TYPES.EMAIL) {
    return {
      description: `${item?.description}`,
      icon: (
        <i
          className="fad fa-envelope"
          style={{
            fontSize: 24,
            width: 28,
            color: "#f1c40f",
          }}
        />
      ),
      img: emailImg,
      to: "/settings/channels/email/" + item?.id,
      name: item?.name,
    }
  }
  if (item?.channelId == CHANNEL_TYPES.CUSTOM) {
    return {
      // description: "Canal customizado",
      description: (item as any)?.hashIdentifier,
      // icon: "fab fa-cuttlefish",
      icon: (
        <i
          className="fab fa-cuttlefish"
          style={{
            fontSize: 24,
            width: 28,
            color: "#e0cd1f",
          }}
        />
      ),
      img: customImg,
      to: "/settings/channels/custom/" + item?.id,
      name: item?.description,
    }
  }
}

export function getStatus(status: IChannelStatus) {
  switch (status) {
    case "connected":
      return {
        title: "Conectado",
        bg: "#27ae60",
        color: "white",
        description: "Seu canal está conectado e funcionando.",
      }
    case "disconnected":
      return {
        title: "Desconectado",
        bg: "#f1c40f",
        description: "Seu canal está desconectado. Verifique sua conexão de internet.",
        className: "!bg-amber-500/20 dark:!bg-amber-500/10 !text-amber-700 dark:!text-amber-200 border-amber-500/10 !border-1 border-solid",
        icon: <IconMageExclamationTriangleFill className="!size-[16px] text-amber-600 dark:text-amber-500" />,
      }
    case "processing_channel":
      return {
        title: "Criando...",
        bg: "#95a5a6",
        description: "Estamos criando seu canal, esse processo poderá demorar até 10 minutos.",
        className:
          "!bg-stone-500/20 !text-stone-700 dark:!text-violet-100 dark:!bg-violet-500/10 dark:border-violet-500/10 border-stone-500/10 !border-1 border-solid",
        icon: <IconMageClockFill className="!size-[16px] text-stone-600 dark:text-violet-300" />,
      }
    case "restarting_channel":
      return {
        title: "Reiniciando...",
        bg: "#95a5a6",
        description: "Estamos reiniciando seu canal, esse processo poderá demorar até 5 minutos.",
        className:
          "!bg-stone-500/20 !text-stone-700 dark:!text-violet-100 dark:!bg-violet-500/10 dark:border-violet-500/10 border-stone-500/10 !border-1 border-solid",
        icon: <IconMageWrenchFill className="!size-[16px] text-stone-600 dark:text-violet-300" />,
      }
    case "login_required":
      return {
        title: "Necessário relogar",
        bg: "#e74c3c",
        description: "Necessário reenviar suas credenciais.",
      }
    case "restart_required":
      return {
        title: "Necessário reiniciar canal",
        bg: "#e74c3c",
        description: 'Vá no seu canal, clique em "ações" e em Reiniciar canal.',
        className:
          "!bg-red-500/20 !text-red-700 border-red-500/10 !border-1 border-solid dark:!text-red-100 dark:!bg-red-500/10 dark:border-red-500/10",
        icon: <IconMageExclamationCircleFill className="!size-[16px] text-red-600 dark:text-red-300" />,
      }
    case "recreate_required":
      return {
        title: "Recomendado recriar canal",
        bg: "#ffeaa7",
        color: "#000",
        description: 'Canal desatualizado. Vá no seu canal, clique em "ações" e em Recriar canal. Será necessário ler o QRCode novamente.',
        className:
          "!bg-amber-500/20 dark:!bg-yellow-500/5 !text-amber-700 dark:!text-yellow-200 border-amber-500/10 !border-1 border-solid",
        icon: <IconMageWrenchFill className="!size-[16px] text-amber-600 dark:text-yellow-300" />,
      }
    case "qr_code":
      return {
        title: "Necessário ler QR-Code",
        bg: "#e67e22",
        description: "Leia o QRCode com seu celular na página do canal para conectar.",
        className:
          "!bg-orange-500/15 !text-orange-700 border-orange-500/10 !border-1 border-solid dark:!text-pink-100 dark:!bg-pink-500/10 dark:border-pink-500/10",
        icon: <IconMageQrCodeFill className="!size-[16px] text-orange-600 dark:text-pink-300" />,
      }
    case "invalid_credentials":
      return { title: "Credenciais inválidos", bg: "#e74c3c" }
    case "invalid_code":
      return { title: "Código inválido", bg: "#e74c3c" }
    case "challenge_required":
      return { title: "Código requerido", bg: "#e74c3c" }
    default:
      return { title: status, bg: "#e74c3c" }
  }
}

function Channels(props: RouteComponentProps) {
  const { all: channels } = useStoreState((state) => state.channels)
  const { all: groups } = useStoreState((state) => state.groups)
  const setModal = useSetAtom(modalState)

  const { remove, patchElementOnAll } = useStoreActions((actions) => actions.channels)
  const customFieldsState = useGenericStore((state) => state.customFields)
  const path = "/settings/channels"
  const [isMobile, setIsMobile] = useAtom(isMobileAtom)
  const { addModal, removeModal } = useStore(general)
  const { workspace, user } = useStore(session)
  const isChannelsGroupLimited = verifyPermission("only_can_see_channels_if_in_channel_group", {
    restrictive: true,
  })

  // const exportData = (channels: IChannel[], xls?: boolean) => {
  //   const data = channels.map((channel) => {
  //     const channelCustoms = customFieldsState.all
  //       ?.filter((c) => c.entity == "channel")
  //       .reduce((acc: any, customField) => {
  //         let name = customField.name
  //         acc[name] = formatCustomInputValue(customField.type, channel?.customFields?.[customField?.placeholder]?.value) || ""
  //         return acc
  //       }, {})
  //     return {
  //       Nome: channel.name || "",
  //       Descrição: channel.description || "",
  //       Tipo: (channelsTypes as any)[channel.channelId]?.path || "",
  //       Telefone: channel?.phone || "",
  //       Identificador: channel?.identifier || "",
  //       Conectado: channel?.status == "connected" ? "Sim" : "Não",
  //       ...channelCustoms,
  //     }
  //   })
  //   exportArray(data, "canais", { xlsx: xls })
  // }

  const columns: ColumnDef<IChannel, any>[] = [
    {
      header: "",
      accessorKey: "channelId",
      // render: (channelId, channel) => {
      cell: (info) => {
        const channelId = info.row.original.channelId
        const channel = info.row.original
        const channelType = (channelsTypes as any)[channelId]
        const channelProps = getProps(channel, workspace) as any
        const avatar = channel.channelId == "6" ? channel.avatar : null
        const channelDef = channelsDef.recordByCode[channelId]
        const isOfficial = channel?.version == WhatsappVersion.API_CLOUD && channel?.channelId == CHANNEL_TYPES.WHATSAPP

        if (isAldeia && channelDef) {
          return (
            <div className="gap-3 items-center fc">
              {/* <div className="text-xl size-9 aspect-square">{channelDef.icon}</div> */}
              <ChannelIcon channelCode={channelId} size="xl" />
              <div className="leading-4 truncate">
                <div className="flex gap-1.5 items-center truncate aldeia:text-sm">{capitalizeWords(channelProps?.name || "")}</div>
                <span className={cn("flex gap-1 items-center truncate text-2xs max-w-80 text-content-200")}>
                  {channelProps?.description}{" "}
                  {isOfficial && (
                    <Tooltip title="WhatsApp Oficial">
                      <IconTablerRosetteDiscountCheckFilled className="opacity-20 transition-all duration-300 hover:opacity-100 hover:text-sky-500 text-stone-500 size-[16px]" />
                    </Tooltip>
                  )}
                  {channel?.isBanned && isAldeia && (
                    <Tooltip title="Seu canal foi possivelmente bloqueado pelo WhatsApp">
                      <IconMageExclamationTriangleFill className="text-red-500 size-[16px]" />
                    </Tooltip>
                  )}
                </span>
              </div>
            </div>
          )
        }

        return (
          <Spin spinning={channel.status == "processing_channel" || channel.status == "restarting_channel"}>
            <Row align="middle" style={{ flexFlow: "nowrap" }} gutter={12}>
              <Col style={{ padding: "16px 11px" }}>
                {channelProps?.icon || (
                  <Avatar
                    name={channelType.name}
                    index={channelId as any}
                    fontSize={12}
                    size={28}
                    imgSrc={avatar || channelProps?.img}
                    // shadow
                    notRounded={!avatar && !channelProps?.rounded}
                  />
                )}
              </Col>
              <Col style={{ lineHeight: "20px" }}>
                <Truncate maxWidth={200} title={channelType.name}>
                  {channelProps?.name}
                </Truncate>
              </Col>
            </Row>
          </Spin>
        )
      },
      size: isAldeia ? 400 : 260,
    },
    ...(isAldeia
      ? []
      : [
          {
            header: "",
            accessorKey: "channelId2",
            cell: (info) => {
              const channelId = info.getValue()
              const channel = info.row.original
              const channelProps = getProps(channel, workspace)
              return <Truncate maxWidth={146}>{channelProps?.description}</Truncate>
            },
            size: 260,
          },
        ]),
    {
      header: "Status",
      accessorKey: "status",
      cell: (info) => {
        const status = info.getValue()
        const channel = info.row.original
        return (
          <Row
            justify="end"
            style={{ textAlign: "right", flex: 1 }}
            align="middle"
            className={cn(isAldeia && "w-auto absolute right-20 top-4.5 z-[10]")}
          >
            <ChannelStatus status={status} truncateMobile={isMobile} channel={channel} />
            {channel?.isBanned && !isAldeia && (
              <Tooltip title="Seu canal foi possivelmente bloqueado pelo WhatsApp">
                <i
                  className="fas fa-solid fa-circle-exclamation"
                  style={{
                    color: "#e74c3c",
                    fontSize: 20,
                    marginLeft: 5,
                  }}
                />
              </Tooltip>
            )}
          </Row>
        )
      },
    },
    // {
    //   key: "action",
    //   fixed: "right",
    //   span: isMobile ? 2 : 2,
    //   width: 60,
    //   render: (text, channel) => (
    //     <TableActionsDropdown>
    //       <Menu
    //         onClick={(e) => {
    //           e.domEvent.stopPropagation()
    //         }}
    //       >
    //         <Menu.Item
    //           key="copy"
    //           icon={<i className={"fal fa-fingerprint"} />}
    //           onClick={() => {
    //             copy(channel.id)
    //             toast.info(`ID do canal (${channel.id}) copiado para clipboard.`)
    //           }}
    //         >
    //           Copiar ID
    //         </Menu.Item>
    //         <Menu.Item key="edit">
    //           <MenuLink iconName={"fal fa-edit"} to={`/settings/channels/${channel.id}`}>
    //             Editar
    //           </MenuLink>
    //         </Menu.Item>
    //         <Separator />
    //         {channel?.channelId == CHANNEL_TYPES.WHATSAPP &&
    //           channel?.version != WhatsappVersion.API_CLOUD &&
    //           whatsappActions(channel).map((zapAction) => (
    //             <Menu.Item
    //               key={zapAction.label}
    //               icon={<i className={zapAction.icon} style={zapAction?.iconStyle}></i>}
    //               onClick={zapAction.onClick}
    //               disabled={zapAction.disabled}
    //             >
    //               {zapAction?.label}
    //             </Menu.Item>
    //           ))}
    //         {channel?.channelId == CHANNEL_TYPES.WHATSAPP && channel?.version != WhatsappVersion.API_CLOUD && <Separator />}
    //         {channel?.channelId == CHANNEL_TYPES.WHATSAPP &&
    //           channel?.version == WhatsappVersion.API_CLOUD &&
    //           whatsappOfficialActions(channel).map((zapAction) => (
    //             <Menu.Item key={zapAction.label} icon={<i className={zapAction.icon}></i>} onClick={zapAction.onClick}>
    //               {zapAction?.label}
    //             </Menu.Item>
    //           ))}
    //         {channel?.channelId == CHANNEL_TYPES.WHATSAPP && channel?.version == WhatsappVersion.API_CLOUD && <Separator />}

    //         <Menu.Item
    //           key="delete"
    //           icon={<i className={"fal fa-trash-alt"} />}
    //           onClick={() => {
    //             showDeleteModalConfirm({
    //               description: "Tem certeza que deseja excluir esse canal?",
    //               onConfirm: () => remove({ id: channel.id }),
    //             })
    //           }}
    //           disabled={isChannelsGroupLimited || channel?.status == "restarting_channel" || channel?.status == "processing_channel"}
    //         >
    //           Excluir
    //         </Menu.Item>
    //       </Menu>
    //     </TableActionsDropdown>
    //   ),
    // },
  ]

  const whatsappActions = useCallback(
    (channel: IChannelWhatsApp, updateLocal) => [
      {
        icon: "fal fa-wifi-slash",
        iconStyle: {
          fontSize: 16,
        },
        iconCustom: <IconHugeiconsWifiDisconnected01 />,
        label: "Desconectar",
        onClick: () => {
          showDeleteModalConfirm({
            title: "Desconectar",
            description: "Tem certeza que deseja desconectar esse canal?",
            onConfirm: () =>
              request.post(endpoints.WHATSAPP_LOGOUT + "/" + channel?.id).then(() => {
                toast.warning("Desconectado o canal de WhatsApp " + channel?.description)
              }),
            okText: "Desconectar",
          })
        },
        disabled: channel?.status == "processing_channel" || channel?.status == "restarting_channel",
      },
      {
        icon: "fal fa-undo",
        iconCustom: <IconHugeiconsRefresh />,
        label: "Reiniciar",
        onClick: () => {
          if (channel?.status == "recreate_required") {
            toast.error("Necessário recriar o canal e ler o QRcode para reiniciar")
          } else {
            showDeleteModalConfirm({
              title: "Reiniciar",
              description: "Tem certeza que deseja reiniciar esse canal?",
              onConfirm: () => {
                return request.post(endpoints.RESTART_CONTAINER + "/" + channel.id)
              },
              okText: "Reiniciar",
            })
          }
        },
        // disabled: channel?.status == "restarting_channel",
      },
      {
        icon: "fal fa-cloud-download",
        iconCustom: <IconHugeiconsCloudDownload />,
        label: "Sincronizar histórico",
        onClick: () => {
          addModal(<SyncZapHistoryModal item={channel} onBackModal={() => removeModal()} />)
        },
        disabled: channel?.status != "connected",
      },
      {
        icon: "fal fa-angle-double-right",
        iconCustom: <IconHugeiconsMessageOutgoing02 />,
        label: "Migrar conversas",
        onClick: () => {
          setModal(<ForwardZapModal channel={channel} onBack={() => setModal(null)} />)
        },
        disabled: isChannelsGroupLimited || verifyPermission("channel_only_simple_maintenance", { restrictive: true }),
      },
      {
        icon: "fal fa-power-off",
        iconCustom: <IconHugeiconsDataRecovery />,
        label: "Recriar",
        onClick: () => {
          showDeleteModalConfirm({
            description: (
              <span>
                Tem certeza que deseja recriar esse canal? Esse processo demora até{" "}
                <span className="text-[var(--system-red-light)]">10 minutos</span>, seu canal ficará indisponível durante esse tempo e você
                deverá ler o QRCode novamente no final do processo.,
              </span>
            ),
            onConfirm: () => {
              return request
                .post(endpoints.RECREATE_CHANNEL + "/" + channel?.id, {
                  description: channel?.description,
                })
                .then((response) => {
                  patchElementOnAll(response.data)
                  updateLocal(response.data)
                })
            },
            okText: "Recriar",
          })
        },
        disabled: channel?.status == "processing_channel",
      },
    ],
    [addModal, patchElementOnAll, removeModal],
  )
  const whatsappOfficialActions = useCallback(
    (channel: IChannelWhatsApp) => {
      const isEmbedded = !!channel?.extraData?.signUpData
      return [
        {
          icon: "fal fa-angle-double-right",
          iconCustom: <IconMageDoubleArrowRight />,
          label: "Migrar conversas",
          onClick: () => {
            setModal(<ForwardZapModal channel={channel} onBack={() => setModal(null)} />)
          },
        },
        // ...(isEmbedded
        //   ? [
        //       {
        //         icon: "fal fa-sync",
        //         label: "Reconectar canal",
        //         iconCustom: <IconMageRefresh />,
        //         onClick: () => {
        //           showInfoModalConfirm({
        //             description:
        //               "Esse processo irá desregistrar e registrar o canal novamente na Meta. Somente faça isso se o canal estiver com problemas.",
        //             onConfirm: () =>
        //               request
        //                 .post(endpoints.WHATSAPP_WBA_CLOUD_SAVE_EMBEDDED_SIGNUP_DATA + "/" + channel.id, {
        //                   workspacePlatformId: channel.id,
        //                   signUpData: {
        //                     business_id: channel.extraData?.signUpData?.business_id!,
        //                     phone_number_id: channel.extraData?.signUpData?.phone_number_id!,
        //                     waba_id: channel.extraData?.signUpData?.waba_id!,
        //                     code: channel.extraData?.signUpData?.code,
        //                   },
        //                 })
        //                 .then(async (res: any) => {
        //                   if (res?.data.status) {
        //                     props.setCount((c: any) => c + 1)
        //                     toast.success(res?.data?.msg)
        //                   } else {
        //                     toast.error(res?.data?.msg)
        //                   }
        //                 }),
        //             okText: "Sim",
        //             title: "Adicionar conexão",
        //           })
        //           request.post(`${endpoints.INTEGRATIONS_REGISTER_CLOUD_API}/${channel?.id}`)?.finally(() => {
        //             hide()
        //           })
        //         },
        //       },
        //     ]
        //   : [
        {
          icon: "fal fa-sync",
          label: "Atualizar registro",
          iconCustom: <IconMageRefresh />,
          onClick: () => {
            const hide = toast.loading("Atualizando registro...")
            request.post(`${endpoints.INTEGRATIONS_REGISTER_CLOUD_API}/${channel?.id}`)?.finally(() => {
              hide()
            })
          },
        },
        // ]),
      ]
    },
    [addModal, patchElementOnAll, removeModal],
  )

  return (
    <TablePageRouter<IChannel>
      {...props}
      title="Canais"
      routeBase="/settings/channels"
      permission="manage_channels"
      queryKey={["channels"]}
      settingsKey="channels"
      layout={isAldeia ? "static" : "default"}
      searchPlaceholder="Pesquisar por nome, descrição ou número"
      columns={columns}
      className="kinbox:[&_thead]:collapse"
      hideNewButton={verifyPermission("channel_only_simple_maintenance", { restrictive: true })}
      permissionFilterFn={(item) => {
        if (isChannelsGroupLimited && !(item.isPrivate && channelIsInUserGroups({ channel: item, groups, workspace, user }))) {
          return false
        }
        if (item?.channelId == CHANNEL_TYPES.WIDGET) {
          return false
        }
        return true
      }}
      filterFn={(item, filters) => {
        if (filters.search) {
          const def = channelsDef.recordByCode[item.channelId]?.getProps(item, workspace)
          return (
            !!def?.name?.toLocaleLowerCase().includes(filters.search.toLocaleLowerCase()) ||
            !!def?.description?.toLocaleLowerCase().includes(filters.search.toLocaleLowerCase())
          )
        }
        return true
      }}
      EditComponent={EditChannel}
      sideCollapsible
      rowHeight={isAldeia ? 62 : undefined}
      storePath={(store) => store.channels}
      rowActions={{
        removeDescription: "Tem certeza que deseja excluir esse canal?",
        hideClone: true,
        hideRemove: verifyPermission("channel_only_simple_maintenance", { restrictive: true }),
        getExtraActions: (channel, { updateLocal }) => [
          <Menu.Item
            key="copy"
            icon={
              <i>
                <Copy01Icon />
              </i>
            }
            onClick={() => {
              copy(channel.id)
              toast.info(`ID do canal (${channel.id}) copiado para clipboard.`)
            }}
          >
            Copiar ID
          </Menu.Item>,
          ...(channel?.channelId == CHANNEL_TYPES.WHATSAPP && channel?.version != WhatsappVersion.API_CLOUD
            ? whatsappActions(channel, updateLocal).map((zapAction) => (
                <Menu.Item
                  key={zapAction.label}
                  icon={isAldeia ? <i>{zapAction.iconCustom}</i> : <i className={zapAction.icon} style={zapAction?.iconStyle}></i>}
                  onClick={zapAction.onClick}
                  disabled={zapAction.disabled}
                >
                  {zapAction?.label}
                </Menu.Item>
              ))
            : []),
          ...(channel?.channelId == CHANNEL_TYPES.WHATSAPP && channel?.version == WhatsappVersion.API_CLOUD
            ? whatsappOfficialActions(channel).map((zapAction) => (
                <Menu.Item
                  key={zapAction.label}
                  icon={isAldeia ? <i>{zapAction.iconCustom}</i> : <i className={zapAction.icon}></i>}
                  onClick={zapAction.onClick}
                >
                  {zapAction?.label}
                </Menu.Item>
              ))
            : []),
        ],
      }}
      newText="Novo canal"
      helpText={{
        description: <span>Conecte os apps que os clientes entrarão em contato com sua empresa</span>,
      }}
      local
      getSegments={
        !isAldeia
          ? undefined
          : (channels) => {
              return [
                [
                  {
                    value: DefaultTableSegment.ALL,
                    label: "Todos os status",
                    labelDefault: "Status",
                    filteredTotal: channels.length,
                  },
                  {
                    label: channelsDef.statusLabel[channelsDef.statusEnum.CONNECTED],
                    value: channelsDef.statusEnum.CONNECTED,
                    filterFn: (c) => c.status == channelsDef.statusEnum.CONNECTED,
                  },
                  {
                    label: channelsDef.statusLabel[channelsDef.statusEnum.DISCONNECTED],
                    value: channelsDef.statusEnum.DISCONNECTED,
                    filterFn: (c) => c.status !== channelsDef.statusEnum.CONNECTED,
                  },
                ],
                [
                  {
                    value: DefaultTableSegment.ALL,
                    label: "Todos os canais",
                    labelDefault: "Canais",
                    filteredTotal: channels.length,
                  },
                  ...channelsDef.array.map((channel) => ({
                    label: channel.label,
                    value: channel.code,
                    filterFn: (c) => c.channelId == channel.code,
                  })),
                ],
              ]
            }
      }
      sorters={[
        {
          id: "channelId",
          label: "Canal",
          sorter: (a, b) => String(a.channelId).localeCompare(String(b.channelId)),
        },
        {
          id: "name",
          label: "A a Z",
          sorter: (a, b) => {
            const def = channelsDef.recordByCode[a.channelId]?.getProps(a, workspace)
            const def2 = channelsDef.recordByCode[b.channelId]?.getProps(b, workspace)
            return def?.name?.localeCompare(def2?.name || "") || 0
          },
        },
        {
          id: "status",
          label: "Status",
          sorter: (a, b) => a.status.localeCompare(b.status),
        },
      ]}
      getExportableData={async (channels) => {
        const exportableData = channels.map((channel) => {
          const channelCustoms = customFieldsState.all
            ?.filter((c) => c.entity == "channel")
            .reduce((acc: any, customField) => {
              let name = customField.name
              acc[name] = formatCustomInputValue(customField.type, channel?.customFields?.[customField?.placeholder]?.value) || ""
              return acc
            }, {})

          const channelProps = channelsDef.recordByCode[channel.channelId]?.getProps(channel, workspace)

          return {
            ID: channel?.id,
            Nome: channelProps?.name || "",
            Descrição: channelProps?.description || "",
            Tipo: (channelsTypes as any)[channel.channelId]?.path || "",
            Telefone: channel?.phone || "",
            Identificador: channel?.identifier || "",
            Conectado: channel?.status == "connected" ? "Sim" : "Não",
            ...channelCustoms,
          }
        })

        return { exportableData, filename: "canais" }
      }}
    />
  )
}

export default Channels
